'use strict';

var Modal = {};

Modal.BaseModal = require('./BaseModal');
Modal.ModalWizard = require('./ModalWizard');
Modal.ModalWizardPage = require('./ModalWizardPage');

module.exports = Modal;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/Modal/index.js
// module id = 36
// module chunks = 0